<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="Edit Term" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field outlined autofocus :hide-details="nameErrors.length === 0" dense :error-messages="nameErrors"
              v-model="Term.name" label="Name"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-select :loading="loading" item-value="id" item-text="name" single-line v-model="Term.YearId" outlined
            :hide-details="yearErrors.length === 0" dense :error-messages="yearErrors"
            :items="years" label="Select Year"></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="submit()"
          >Update</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import yearService from "@/modules/ReportCard/Year/service.js";
import termService from "../service.js";

const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  props: {
    editDialog: {
      default: false,
    },
    editTerm: {
      type: Object,
    },
  },
  name: "update-term",
  data() {
    return {
      loading: false,
      dialog: false,
      years: [],
      Term: {
        name: null,
        YearId: null,
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    Term: {
      name: {
        required,
      },
      YearId: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Term.name.$dirty) return errors;
      if (!this.$v.Term.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
    yearErrors() {
      const errors = [];
      if (!this.$v.Term.YearId.$dirty) return errors;
      if (!this.$v.Term.YearId.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  watch: {
    editDialog(val) {
      this.Term = JSON.parse(JSON.stringify(this.editTerm));
      this.dialog = val;
      if(val)
        this.getYear()
    },
  },
  methods: {
    getYear() {
      this.loading = true;
      yearService.getAll().then(response => {
        this.loading = false;
        this.years = response.data
      }).catch(error => {
        this.loading = false;
        console.log('error getting year', error)
      })
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Term = {
        name: null,
        YearId: null,
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        return termService
          .update(this.Term.id, this.Term)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Term is updated",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
